import { portalApi } from '@/axios'

const batchStatuses = ['Any', 'Open', 'Closed']

const beneficiaryStatuses = ['Approved', 'Referred', 'Rejected']

const channels = ['All', 'Gateway', 'Acquiring', 'Chp']

const genders = ['Female', 'Male']

const phoneNumberTypes = ['Unknown', 'Mobile', 'Fixed']

const salutations = ['Mr.', 'Mrs.', 'Miss.', 'Dr.', 'Ms.']

const ticketStatuses = ['Open', 'InProgress', 'OnHold', 'Closed']

const ticketPriorities = ['Unknown', 'Low', 'Medium', 'High']

export default class EnumerationService {
  /**
   * Get batch statuses
   *
   * @return {Promise}
   */
  static getBatchStatuses () {
    return Promise.resolve({ data: batchStatuses })
  }

  /**
   * Get beneficiary statuses
   *
   * @return {Promise}
   */
  static getBeneficiaryStatuses () {
    return Promise.resolve({ data: beneficiaryStatuses })
  }

  /**
   * Get channels
   *
   * @return {Promise}
   */
  static getChannels () {
    return Promise.resolve({ data: channels })
  }

  /**
   * Get countries
   *
   * @param {Object} parameters
   *
   * @return {Promise}
   */
  static getCountries (parameters) {
    return this.getEnumeration(`${this.endpoint()}/countries`, parameters)
  }

  /**
   * Get currencies
   *
   * @param {Object} parameters
   *
   * @return {Promise}
   */
  static getCurrencies (parameters) {
    return this.getEnumeration(`${this.endpoint()}/currencies`, parameters)
  }

  /**
   * Get genders
   *
   * @return {Promise}
   */
  static getGenders () {
    return Promise.resolve({ data: genders })
  }

  /**
   * Get order line types
   *
   * @param {Object} parameters
   *
   * @return {Promise}
   */
  static getOrderLineTypes (parameters) {
    return this.getEnumeration(`${this.endpoint()}/order-line-types`, parameters)
  }

  /**
   * Get payment methods
   *
   * @param {Object} parameters
   *
   * @return {Promise}
   */
  static getPaymentMethods (parameters) {
    return this.getEnumeration(`${this.endpoint()}/payment-methods`, parameters)
  }

  /**
   * Get payment statuses
   *
   * @param {Object} parameters
   *
   * @return {Promise}
   */
  static getPaymentStatuses (parameters) {
    return this.getEnumeration(`${this.endpoint()}/payment-statuses`, parameters)
  }

  /**
   * Get phone number types
   *
   * @return {Promise}
   */
  static getPhoneNumberTypes () {
    return Promise.resolve({ data: phoneNumberTypes })
  }

  /**
   * Get salutations
   *
   * @return {Promise}
   */
  static getSalutations () {
    return Promise.resolve({ data: salutations })
  }

  /**
   * Get ticket priorities
   *
   * @return {Promise}
   */
  static getTicketPriorities () {
    return Promise.resolve({ data: ticketPriorities })
  }

  /**
   * Get ticket statuses
   */
  static getTicketStatuses () {
    return Promise.resolve({ data: ticketStatuses })
  }

  /**
   * Get ticket types
   *
   * @param {Object} parameters
   *
   * @return {Promise}
   */
  static getTicketTypes (parameters) {
    return this.getEnumeration(`${this.endpoint()}/ticket-types`, parameters)
  }

  /**
   * Get resource
   *
   * @param {String} url
   * @param {Object} parameters
   *
   * @return {Promise}
   */
  static getEnumeration (url, parameters) {
    return portalApi.get(url, {
      params: parameters || null
    }).then(response => {
      return response.data
    }).catch(error => {
      return Promise.reject(error)
    })
  }

  /**
   * Endpoint of API.
   *
   * @return {string}
   */
  static endpoint () {
    return `/enumerations`
  }
}
